import formats from '../../api/formats'

const state = {
}

// getters
const getters = {
  renderReference: (state, getters) => (item, target) => {
    return ''.concat(
      '<span>',
      getters.getRefIsValid(item.ref) ? `<a href=${getters.getRefToUrl(item.ref)} ${target ? 'target="' + target + '"' : ''}>` : ``,
      `<b>${item.caption}</b>`,
      getters.getRefIsValid(item.ref) ? `</a>` : ``,
      '</span>'
      )
  },
  renderHeads: (state, getters) => (ref) => {
    let result = []
    if (ref.management) {
      result = result.concat('Управляющая компания: ' + ref.management)
    }
    if (ref.heads) {
      if (ref.namespace === 'ogrnip') {
        result = result.concat(ref.heads.map(h => ''.concat(h.nameShort)))
      } else {
        result = result.concat(ref.heads.map(h => ''.concat(h.position, ': ', h.nameShort)))
      }
    }
    return result.join(', ')
  },
  renderEmployeeReference: (state, getters) => (item, target) => {
    console.log('renderEmployeeReference', item)
    return ''.concat(
      '<span>',
      getters.getRefIsValid(item.ref) ? `<a href=${getters.getRefToUrl(item.ref)} ${target ? 'target="' + target + '"' : ''}>` : ``,
      `<b>${item.nameFull}</b>`,
      getters.getRefIsValid(item.ref) ? `</a>` : ``,
      '</span>'
      )
  },
  renderShare: (state, getters) => (share) => {
    if (share == null) {
      return ''
    }
    var typeCode = share.typeCode
    var numerator = formats.getValue(share, ['part', 'numerator'])
    var denominator = formats.getValue(share, ['part', 'denominator'])
    denominator = denominator !== 0 ? denominator : null
    if (numerator !== null && denominator !== null) {
      switch (typeCode) {
        case 'PERCENT':
          return numerator / denominator + '% '
        case 'FLOAT':
          return formats.formatNumber(numerator / denominator) + ' '
        case 'PART':
          return numerator + '/' + denominator + ' '
      }
    }
    return ''
  },
  renderHolderPercent: (state, getters) => (item) => {
    var share = formats.getValue(item, ['shares', 0])
    return ''.concat(
      '<span>',
      getters.getRefIsValid(item.ref) ? `<a href=${getters.getRefToUrl(item.ref)}>` : ``,
      '<b>',
      getters.renderShare(share),
      item.caption,
      '</b>',
      getters.getRefIsValid(item.ref) ? `</a>` : ``,
      '</span>'
      )
  },
  renderInnHtml: (state, getters) => (inn) => {
    return formats.isInn(inn) ? formats.formatInn(inn) : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об ИНН')
  },
  renderInnflHtml: (state, getters) => (inn) => {
    return formats.isInnfl(inn) ? formats.formatInnfl(inn) : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об ИНН')
  },
  renderInnOrInnflHtml: (state, getters) => (inn) => {
    return formats.isInn(inn) || formats.isInnfl(inn) ? inn : formats.formatWarningHtml('Запись об ИНН не найдена')
  },
  renderDateSince: (state, getters) => (valueDTO) => {
    if (!valueDTO ||
     (!valueDTO.created && !valueDTO.updated)) {
      return ''
    }
    var result = ''
    result = result.concat(
      ' (c',
      '\xa0',
      valueDTO.created ? formats.formatDate(valueDTO.created) : formats.formatDate(valueDTO.updated),
      valueDTO.created && valueDTO.updated && valueDTO.created !== valueDTO.updated ? ', изменено ' + formats.formatDate(valueDTO.updated) : '',
      valueDTO.created && valueDTO.updated && valueDTO.created !== valueDTO.updated && valueDTO.deleted ? ',' : '',
      valueDTO.deleted ? ' по ' + formats.formatDate(valueDTO.deleted) : '',
     ')')
    return result
  },
  renderStatus: (state, getters) => (status) => {
    var text = status ? status.text : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об статусе компании')
    if (status) {
      if (status.kind === 'GOOD') {
        text = formats.formatSuccessHtml(status.text)
      }
      if (status.kind === 'WARN') {
        text = formats.formatWarningHtml(status.text + ' (' + formats.formatDate(status.updated) + ')')
      }
      if (status.kind === 'BAD') {
        text = formats.formatErrorHtml(status.text + ' (' + formats.formatDate(status.updated) + ')')
      }
      if (status.kind === 'OLD') {
        text = formats.formatErrorHtml(status.text + ' (' + formats.formatDate(status.updated) + ')')
      }
    }
    return ''.concat(
      '<b>',
      text,
      '</b>'
      )
  },
  renderFlags: (state, getters) => (companyFlags, small) => {
    if (!(companyFlags && Array.isArray(companyFlags) && companyFlags.length > 0)) {
      return null
    }
    const flagList = [
      {code: '0401', icon: 'monetization_on', class: 'warning--text', text: 'Начата процедура банкротства'},
      {code: '0402', icon: 'monetization_on', class: 'error--text', text: 'Банкротство неизбежно'},
      {code: '0301', icon: 'outlined_flag', class: 'error--text', text: 'Недостоверные данные'},
      {code: '0201', icon: 'error_outline', class: 'error--text', text: 'Действующее ЮЛ со статусами, связанными с последующей ликвидацией (прекращением деятельности)'},
      {code: '0202', icon: 'error_outline', class: 'warning--text', text: 'Действующее ЮЛ со статусами изменения ключевого показателя, не связанного с обязательной ликвидацией'},
      {code: '0203', icon: 'not_interested', class: 'error--text', text: 'Недействующее ЮЛ (потеря дееспособности и правоспособности)'}
    ]
    let template = `
      <v-tooltip lazy bottom open-delay="500" max-width="20em">
        <span slot="activator">
          <template v-for="flag in flags">
            <v-icon :small="small" :class="flag.class">{{flag.icon}}</v-icon>
          </template>
        </span>
          <template v-for="flag in flags">
            <div>
              <v-icon small :class="flag.class">{{flag.icon}}</v-icon>
              {{flag.text}}
            </div>
          </template>
      </v-tooltip>
    `
    let flagSet = new Set(companyFlags.map(f => f.code))
    let flags = flagList.filter(f => flagSet.has(f.code))
    return {
      template: template,
      data: function () {
        return {
          flags: flags,
          small: small
        }
      }
    }
  },
  renderFirstActivityHtml: (state, getters) => (activities) => {
    return activities && activities.length > 0 && activities[0].name ? activities[0].name : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о видах деятельности компании')
  },
  renderUnreliable: (state, getters) => (unreliableDTO) => {
    if (!unreliableDTO ||
     !unreliableDTO.unreliables ||
     unreliableDTO.unreliables.length === 0) {
      return ''
    }
    var result = ''
    unreliableDTO.unreliables.forEach(u => {
      result = result.concat(
        u.unreliableText ? u.unreliableText[0].toUpperCase() + u.unreliableText.slice(1) : 'Cведения недостоверны',
        u.unreliableDate ? ' (' + formats.formatDate(u.unreliableDate) + ')' : ''
      )
    })
    return result
  },
  renderUnreliableHtml: (state, getters) => (unreliableDTO) => {
    return formats.formatWarningHtml(getters.renderUnreliable(unreliableDTO))
  },
  renderCopyButton: (state, getters) => (hint, action, param) => {
    var template = ''.concat(
      `<span><v-tooltip bottom open-delay="500">
        <span slot="activator">
          <v-btn style="margin:0" small icon @click="copyToClipboard">
            <v-icon small>{{icon}}</v-icon>
          </v-btn>
        </span>
        <span>{{hint}}</span>
      </v-tooltip></span>`
    )
    return {
      template: template,
      data: function () {
        return {
          icon: 'content_copy',
          hint: hint,
          action: action
        }
      },
      methods: {
        copyToClipboard () {
          var text = action(param)
          this.$store.dispatch('copyToClipboard', {text: text})
        }
      }
    }
  },
  renderContactButton: (state, getters) => (hint, action, param) => {
    var template = ''.concat(
      `<span><v-tooltip bottom open-delay="500">
        <span slot="activator">
          <v-btn style="margin:0" small icon @click="onClick">
            <v-icon small>{{icon}}</v-icon>
          </v-btn>
        </span>
        <span>{{hint}}</span>
      </v-tooltip></span>`
    )
    return {
      template: template,
      data: function () {
        return {
          icon: 'person_outline',
          hint: hint,
          action: action
        }
      },
      methods: {
        onClick () {
          action(param)
        }
      }
    }
  },
  renderValueLink: (state, getters) => (value, label, link, hint, html, post) => {
    let caption = html || `<b>${value}</b>`
    var template = ''.concat(
      `<span ><v-tooltip :disabled="!hint" bottom open-delay="500">
        <span slot="activator">
          {{label ? label + '&nbsp' : ''}}
          <span style="white-space: normal;">
            <a v-if="link" href="link" v-html="caption"></a>
            <span v-if="!link" v-html="caption"></span>
            <span v-if="post">&nbsp{{post}}&nbsp</span>
          <v-btn style="margin:0" small icon @click="copyToClipboard()">
            <v-icon small height="16px" width="16px" >{{icon}}</v-icon>
          </v-btn>
          </span>
        </span>
        <span v-show="hint">{{hint}}</span>
      </v-tooltip></span>`
    )
    return {
      template: template,
      data: function () {
        return {
          icon: 'content_copy',
          hint: hint,
          label: label,
          link: link,
          caption: caption,
          post: post
        }
      },
      methods: {
        copyToClipboard () {
          this.$store.dispatch('copyToClipboard', {text: value})
        }
      }
    }
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ClientRender.js